<template>
  <div v-if="!showDetails">
    <v-card class="form" v-if="Object.keys(schools).length > 0">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="12">
          لطفا استان و شهر را انتخاب کنید:
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="2">
          <b>استان:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="4">
          <v-select :items="Object.keys(schools)" v-model="ostan" @change="updateCity"
            no-data-text="داده ای برای نمایش وجود ندارد."></v-select>
        </v-col>
        <v-col class="d-flex" cols="12" sm="2">
          <b>شهر:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="4">
          <v-select :items="cities" v-model="shahr" no-data-text="داده ای برای نمایش وجود ندارد."></v-select>
        </v-col>
      </v-row>
    </v-card>
    <div v-else style="margin: 20px">
      در این تاریخ، درخواست انتقال به هیچ مدرسه ای میسر نمی باشد
    </div>
    <app-school v-for="index in citySchools.length" :index="index - 1" :key="index" :school="citySchools[index - 1]"
      :showDetails="false" @clicked="onClickSchool">
    </app-school>
  </div>
  <div v-else>
    <app-school :school="citySchools[selectedSchool]" :showDetails="true">
    </app-school>
    <app-request :schoolID="citySchools[selectedSchool].ID" @clicked="sendRequest">
    </app-request>
  </div>
</template>

<script>
import School from "./School";
import Request from "./OstanRequest";
import { transferToOstanRequest } from "@/api/transfer";
export default {
  components: {
    appSchool: School,
    appRequest: Request,
  },
  created() {
    if (this.$route.query.index) {
      this.$router.replace({
        query: {}
      })
    }
    this.$store.dispatch("getActiveSchools", true).then(() => {
      if (Object.keys(this.schools).length > 0) {
        this.ostan = Object.keys(this.schools)[0];
        this.shahr = Object.keys(this.schools[this.ostan])[0];
      }
    });
  },
  methods: {
    updateCity() {
      this.shahr = Object.keys(this.schools[this.ostan])[0];
    },
    onClickSchool(id) {
      this.$store.commit("SET_HEADER_TITLE", "انتخاب مدرسه مقصد");
      window.scrollTo(0, 0);
      this.$router.push({
        query: {

          index: id
        }
      });

    },
    sendRequest(file, schoolID, comment) {
      /**
       * call api
       */
      transferToOstanRequest(file, schoolID, comment)
        .then((response) => {
          const data = response.data;
          this.$router.push({ path: "/index" });
          this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
        })

        .catch((error) => { });
    },
  },
  computed: {
    schools() {
      return this.$store.getters.schools;
    },
    cities() {
      return this.schools.hasOwnProperty(this.ostan)
        ? Object.keys(this.schools[this.ostan])
        : [];
    },
    citySchools() {
      return this.schools.hasOwnProperty(this.ostan)
        ? this.schools[this.ostan].hasOwnProperty(this.shahr)
          ? this.schools[this.ostan][this.shahr]
          : []
        : [];
    },
    showDetails() {
      return this.selectedSchool > -1;
    },
  },
  data() {
    return {
      ostan: "",
      shahr: "",
      selectedSchool: -1,
    };
  },
  watch: {

    '$route'(to, from) {
      this.selectedSchool = this.$route.query.index ?? -1;

    }
  },


};
</script>
<style scoped>
.v-card {
  cursor: pointer;
}

@media (max-width: 768px) {
  .col-sm-4 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>
